import Config from 'config';
import Ajax from './ajax';
import Url from './urls';

module.exports = {
  properties: slug => Ajax.get(Config.server_url + Url.properties(slug)),
  profile: code => Ajax.get(Config.server_url + Url.profile(code)),
  reviews: (code, page, rating = undefined, count = 3) =>
    Ajax.get(Config.server_url + Url.reviews(code), null, { page, count, rating }),
  reviewMetrics: code => Ajax.get(Config.server_url + Url.reviewMetrics(code)),
  offers: (code, page) => Ajax.get(Config.server_url + Url.offers(code), null, { page }),
  products: (code, page) => Ajax.get(Config.server_url + Url.products(code), null, { page }),
  banners: code => Ajax.get(Config.server_url + Url.banners(code)),
  services: code => Ajax.get(Config.server_url + Url.services(code)),
  addReview: (code, headers, data) => Ajax.post(Config.server_url + Url.addReview(code), headers, data),
  generateOtp: phoneNumber => Ajax.post(
    Config.server_url + Url.generateOtp(), null, JSON.stringify({ phone_number: phoneNumber, source: 'member' })),
  addServiceRequest: (code, headers, data) => Ajax.post(
    Config.server_url + Url.addServiceRequest(code), headers, data),
  addMember: (headers, data) => Ajax.post(Config.server_url + Url.addMember(), headers, data),
};



// WEBPACK FOOTER //
// ./utils/api.js